exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper[data-v-7e262a82]{width:100%;padding:25px 15%\n}\n@media(max-width: 1200px){\n.form-wrapper[data-v-7e262a82]{padding:10px .5%;margin-left:0\n}\n}\n.form-wrapper .md-layout[data-v-7e262a82]{margin-bottom:5px\n}\n.disclaimer-check[data-v-7e262a82]{margin-top:20px\n}\n.form-wrapper-frame[data-v-7e262a82]{width:100%;padding:25px;margin-bottom:15px\n}\n.title-icon[data-v-7e262a82]{margin-top:-5px\n}\n.form-divider[data-v-7e262a82]{padding:10px 0\n}\n.playlist-select.input-container[data-v-7e262a82]{padding-left:12px;padding-right:12px;max-width:100%\n}\n#submit-btn[data-v-7e262a82]{margin-bottom:50px;width:33%;padding:6px;font-size:1.1em\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7e262a82","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/mediaSource/MediaSourceForm.vue
// module id = 208
// module chunks = 0